import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

const ICONIFY_SCRIPT_ID = 'milinco-iconify-cdn';
const ICONIFY_SRC = 'https://code.iconify.design/2/2.0.3/iconify.min.js';

/**
 * Iconify CDN is only needed for admin shell (Solar icons). Public landing
 * uses Tabler + inline brand SVGs — keep the script out of index.html cold path.
 */
@Injectable({ providedIn: 'root' })
export class IconifyLoaderService {
  private loaded = false;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  ensureLoaded(): void {
    if (this.loaded || !isPlatformBrowser(this.platformId)) {
      return;
    }
    if (document.getElementById(ICONIFY_SCRIPT_ID)) {
      this.loaded = true;
      return;
    }
    const script = document.createElement('script');
    script.id = ICONIFY_SCRIPT_ID;
    script.src = ICONIFY_SRC;
    script.defer = true;
    document.head.appendChild(script);
    this.loaded = true;
  }
}
